import baseAPI from '@/http'

const router = 'api/govInstituicao'

export const instituicaoAPI = {
  create: (instituicao) => baseAPI.post(router + '/cadastrar-instituicao', instituicao),
  update: (instituicao) => baseAPI.put(router + '/atualizar-instituicao', instituicao),
  delete: (id) => baseAPI.delete(`${router}/excluir-instituicao/${id}`),
  list: (filtro) => baseAPI.post(`${router}/obter-instituicoes-por-filtro`, filtro),
  get: (id) => baseAPI.get(`${router}/${id}`),
}
